"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHasCompanyActivePremiumCompanyProfileSubscription = getHasCompanyActivePremiumCompanyProfileSubscription;
exports.getCompanyActivePremiumCompanyProfileSubscription = getCompanyActivePremiumCompanyProfileSubscription;
const dayjs_1 = __importDefault(require("dayjs"));
function getHasCompanyActivePremiumCompanyProfileSubscription(companySubscriptions) {
    const now = (0, dayjs_1.default)();
    const hasActivePremiumSubscription = companySubscriptions === null || companySubscriptions === void 0 ? void 0 : companySubscriptions.some(({ startDate, endDate, deletedAt }) => {
        const isStartDateBeforeNow = (0, dayjs_1.default)(startDate).isBefore(now);
        const isEndDateAfterNow = (0, dayjs_1.default)(endDate).isAfter(now);
        return isStartDateBeforeNow && isEndDateAfterNow && !deletedAt;
    });
    return Boolean(hasActivePremiumSubscription);
}
function getCompanyActivePremiumCompanyProfileSubscription(companySubscriptions) {
    const now = (0, dayjs_1.default)();
    const activePremiumSubscription = companySubscriptions === null || companySubscriptions === void 0 ? void 0 : companySubscriptions.find(({ startDate, endDate, deletedAt }) => {
        const isStartDateBeforeNow = (0, dayjs_1.default)(startDate).isBefore(now);
        const isEndDateAfterNow = (0, dayjs_1.default)(endDate).isAfter(now);
        return isStartDateBeforeNow && isEndDateAfterNow && !deletedAt;
    });
    return activePremiumSubscription;
}
